import React from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  rating: number;
  count?: number;
  size?: number;
  showCount?: boolean;
}

export default function StarRating({ rating, count, size = 14, showCount = true }: StarRatingProps) {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={`star-${star}`}
          size={size}
          className={star <= Math.round(rating) ? 'fill-current' : ''}
          style={{ color: star <= Math.round(rating) ? 'var(--amber)' : 'var(--border)' }}
        />
      ))}
      {showCount && count !== undefined && (
        <span className="text-xs ml-1" style={{ color: 'var(--muted-foreground)' }}>
          ({count})
        </span>
      )}
    </div>
  );
}